import en from './en';

type Translation = {
  [key in keyof typeof en]: string;
};

type ClassTranslations = {
  [lang: string]: Translation;
};

export const classTranslations: ClassTranslations = {
  en,
};
